import StyleSheet from 'react-native-extended-stylesheet';

const menuMobileHeight = 54;
const menuDesktopHeight = 48;

const style = StyleSheet.create({
  navBarContainer: {
    borderBottomWidth: '$borderWidth1',
    borderColor: '$colorBorderInteractive',
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'space-between',
    backgroundColor: '$colorBgBase',
    height: menuMobileHeight,
  },
  navBarLarge: {
    height: menuDesktopHeight,
    borderBottomWidth: 0,
    alignContent: 'center',
    alignItems: 'center',
  },
});
export {style, menuMobileHeight, menuDesktopHeight};
